<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FMEP">What chance has a woman got?</p>
<p class="FMEPC">—Barbara Stanwyck, <span class="ePub-I">Baby Face,</span> 1933</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraphs.vue?6e57c17c